const EDITABLE_DISCOVER_OBJECT_TYPES = new Set(['EVENT', 'SESSION', 'VENUE']);
const CANONICAL_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

function normalizeObjectType(value) {
    if (typeof value !== 'string') {
        return null;
    }
    const normalized = value.trim().toUpperCase();
    return EDITABLE_DISCOVER_OBJECT_TYPES.has(normalized) ? normalized : null;
}

function normalizeObjectId(value) {
    if (typeof value !== 'string') {
        return null;
    }
    const normalized = value.trim();
    return CANONICAL_UUID_REGEX.test(normalized) ? normalized : null;
}

export function createDiscoverEditIntent({ objectType, objectId }) {
    const normalizedObjectType = normalizeObjectType(objectType);
    const normalizedObjectId = normalizeObjectId(objectId);

    if (!normalizedObjectType || !normalizedObjectId) {
        return null;
    }

    return {
        mode: 'edit',
        objectType: normalizedObjectType,
        objectId: normalizedObjectId,
    };
}

export function readDiscoverEditIntent(state) {
    if (!state || typeof state !== 'object') {
        return null;
    }
    return createDiscoverEditIntent(state.discoverComposerIntent || {});
}
